import { render } from "./PaymentLinkPanel.vue?vue&type=template&id=04a8df57&scoped=true"
import script from "./PaymentLinkPanel.vue?vue&type=script&lang=js"
export * from "./PaymentLinkPanel.vue?vue&type=script&lang=js"

import "./PaymentLinkPanel.vue?vue&type=style&index=0&id=04a8df57&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04a8df57"]])

export default __exports__